import React, { Fragment } from 'react'
import { ThemeProvider } from 'react-fela'
import { FelaProvider, createRenderer } from './index'

const key = '__FELA_RENDERER__'

const getRenderer = (theme) => {
  if (typeof window !== 'undefined') {
    if (!window[key]) {
      window[key] = createRenderer(theme)
    }
    return window[key]
  }
  return createRenderer(theme)
}

export const StylingProvider = ({ theme }) => {
  const renderer = getRenderer(theme)

  return ({ children }) => (
    <FelaProvider renderer={renderer}>
      <ThemeProvider theme={{ ...theme, spacingMultiplier: theme.spacingMultiplier || 8 }}>
        <Fragment>{children}</Fragment>
      </ThemeProvider>
    </FelaProvider>
  )
}

export default StylingProvider
